import { QRCodeSVG } from 'qrcode.react';
import { Download, Share2, Smartphone } from 'lucide-react';
import { Button } from '@/components/ui/button';

const APP_URL = 'https://app.momsbiznetwork.co.za';

export default function InstallPage() {
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Mom's Biz Network",
          text: "Join our women's business networking community!",
          url: APP_URL
        });
      } catch (e) { /* user cancelled */ }
    } else {
      navigator.clipboard.writeText(APP_URL);
      alert('Link copied to clipboard!');
    }
  };

  const handleDownloadQR = () => {
    const svg = document.querySelector('#mbn-qr-code svg');
    if (!svg) return;
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    canvas.width = 600;
    canvas.height = 600;
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.onload = () => {
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, 600, 600);
      ctx.drawImage(img, 0, 0, 600, 600);
      const link = document.createElement('a');
      link.download = 'mbn-install-qr.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    };
    img.src = 'data:image/svg+xml;base64,' + btoa(svgData);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#f0f5f8] to-white flex items-center justify-center px-4 py-12" data-testid="install-page">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-[#2d3748] mb-2">
            Get the App
          </h1>
          <p className="text-[#64748b]">
            Scan the QR code or tap the button below to install Mom's Biz Network on your phone
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8 text-center" data-testid="qr-card">
          <div id="mbn-qr-code" className="inline-block p-4 bg-white rounded-xl border-2 border-[#5b7f95]/20">
            <QRCodeSVG
              value={APP_URL}
              size={220}
              level="H"
              fgColor="#2d3748"
              bgColor="#ffffff"
              imageSettings={{
                src: '/logo.png',
                x: undefined,
                y: undefined,
                height: 40,
                width: 40,
                excavate: true,
              }}
            />
          </div>
          
          <p className="mt-4 text-sm text-[#64748b]">
            Point your camera at the QR code
          </p>

          <div className="mt-6 space-y-3">
            <Button
              onClick={() => window.open(APP_URL, '_blank')}
              className="w-full bg-[#5b7f95] hover:bg-[#4a6b7f] text-white py-3 rounded-full"
              data-testid="open-app-btn"
            >
              <Smartphone className="w-4 h-4 mr-2" />
              Open the App
            </Button>
            
            <div className="flex gap-3">
              <Button
                variant="outline"
                onClick={handleShare}
                className="flex-1 border-[#cb9944] text-[#cb9944] hover:bg-[#cb9944]/10 rounded-full"
                data-testid="share-link-btn"
              >
                <Share2 className="w-4 h-4 mr-2" />
                Share Link
              </Button>
              <Button
                variant="outline"
                onClick={handleDownloadQR}
                className="flex-1 border-[#5b7f95] text-[#5b7f95] hover:bg-[#5b7f95]/10 rounded-full"
                data-testid="download-qr-btn"
              >
                <Download className="w-4 h-4 mr-2" />
                Save QR
              </Button>
            </div>
          </div>
        </div>

        <div className="mt-8 bg-white rounded-2xl shadow-lg p-6">
          <h2 className="font-semibold text-[#2d3748] mb-4">How to Install</h2>
          <div className="space-y-4 text-sm text-[#64748b]">
            <div className="flex gap-3">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#5b7f95] text-white text-xs flex items-center justify-center font-bold">1</span>
              <p>Open the link in your phone's browser (Chrome or Safari)</p>
            </div>
            <div className="flex gap-3">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#5b7f95] text-white text-xs flex items-center justify-center font-bold">2</span>
              <div>
                <p><strong>Android:</strong> Tap "Add to Home Screen" when prompted</p>
                <p className="mt-1"><strong>iPhone:</strong> Tap the Share button, then "Add to Home Screen"</p>
              </div>
            </div>
            <div className="flex gap-3">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#5b7f95] text-white text-xs flex items-center justify-center font-bold">3</span>
              <p>Sign in with your email and password</p>
            </div>
            <div className="flex gap-3">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#cb9944] text-white text-xs flex items-center justify-center font-bold">4</span>
              <p>Allow notifications to stay in the loop!</p>
            </div>
          </div>
        </div>

        <p className="text-center text-xs text-[#94a3b8] mt-6">
          Mom's Biz Network — Women Supporting Women
        </p>
      </div>
    </div>
  );
}
